import { render } from "./NewsShow.vue?vue&type=template&id=c0908cec&scoped=true"
import script from "./NewsShow.vue?vue&type=script&lang=js"
export * from "./NewsShow.vue?vue&type=script&lang=js"

import "./NewsShow.vue?vue&type=style&index=0&id=c0908cec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0908cec"]])

export default __exports__